import { ErrorTemplate } from "./ErrorTemplate";
import type { ErrorTemplateProps } from "./ErrorTemplateComponent";

export interface SomethingWentWrongProps extends Omit<
  ErrorTemplateProps,
  "title" | "errorCode"
> {}

/**
 * 500 Error Page
 */
export const SomethingWentWrong = (props: SomethingWentWrongProps) => (
  <ErrorTemplate errorCode={500} {...props} />
);
